module.exports = __webpack_public_path__ + "img/negocio-de-locacao.a295719f.jpg";